import Http from 'axios';
import Builder from '@app/store/builder';
const STATE = Builder.state({
    members: [],
    teams: [],
    jobs: [],
}, 'Company');
const GETTERS = {
    getMemberById(id) {
        return STATE.members.find(event => event.id == id) || null;
    },
    getTeamById(id) {
        return STATE.teams.find(event => event.id == id) || null;
    },
    getJobById(id) {
        return STATE.jobs.find(event => event.id == id) || null;
    },
};
const MUTATIONS = {
    setMembers(members) {
        STATE.members = members;
    },
    setTeams(teams) {
        STATE.teams = teams;
    },
    setJobs(jobs) {
        STATE.jobs = jobs;
    },
};
const ACTIONS = {
    async loadMembers() {
        const response = await Http.get('/api/company/member');
        MUTATIONS.setMembers(response.data);
        return response;
    },
    async loadTeams() {
        const response = await Http.get('/api/company/team');
        MUTATIONS.setTeams(response.data);
        return response;
    },
    async loadJobs() {
        const response = await Http.get('/api/company/job');
        MUTATIONS.setJobs(response.data);
        return response;
    },
};
export default {
    STATE,
    GETTERS,
    MUTATIONS,
    ACTIONS
};
